"use client";

import _slicedToArray from "/home/keoadmin/agent/_work/123/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/keoadmin/agent/_work/123/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/keoadmin/agent/_work/123/s/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["transition"],
  _excluded2 = ["className", "disabled", "buttonStyle", "linesStyle", "portrait", "style"],
  _excluded3 = ["boxSizing", "objectFit", "objectPosition"],
  _excluded4 = ["boundsPadding", "browsingContext", "changePositionOnHover", "disabled", "handle", "itemOne", "itemTwo", "keyboardIncrement", "onlyHandleDraggable", "onPositionChange", "portrait", "position", "style", "transition"],
  _excluded5 = ["style"];
import "core-js/modules/esnext.global-this.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef as be, useCallback as P, useEffect as k, useImperativeHandle as He, useRef as M, useState as V } from "react";
import { forwardRef as ee } from "react";
import { jsx as te } from "react/jsx-runtime";
var B = ee(function (_ref, r) {
  var e = _ref.transition,
    t = _objectWithoutProperties(_ref, _excluded);
  var o = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    transition: e ? "clip-path ".concat(e) : void 0,
    userSelect: "none",
    willChange: "clip-path, transition",
    KhtmlUserSelect: "none",
    MozUserSelect: "none",
    WebkitUserSelect: "none"
  };
  return te("div", _objectSpread(_objectSpread({}, t), {}, {
    style: o,
    "data-rcs": "clip-item",
    ref: r
  }));
});
B.displayName = "ContainerClip";
var W = ee(function (_ref2, m) {
  var e = _ref2.children,
    t = _ref2.disabled,
    r = _ref2.portrait,
    o = _ref2.position,
    i = _ref2.transition;
  var u = {
    position: "absolute",
    top: 0,
    width: r ? "100%" : void 0,
    height: r ? void 0 : "100%",
    background: "none",
    border: 0,
    padding: 0,
    pointerEvents: "all",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    outline: 0,
    transform: r ? "translate3d(0, -50% ,0)" : "translate3d(-50%, 0, 0)",
    transition: i ? "".concat(r ? "top" : "left", " ").concat(i) : void 0
  };
  return te("button", {
    ref: m,
    "aria-label": "Drag to move or focus and use arrow keys",
    "aria-orientation": r ? "vertical" : "horizontal",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": o,
    "data-rcs": "handle-container",
    disabled: t,
    role: "slider",
    style: u,
    children: e
  });
});
W.displayName = "ThisHandleContainer";
import { jsx as H, jsxs as ne } from "react/jsx-runtime";
var re = function re(_ref3) {
    var e = _ref3.flip;
    return H("div", {
      className: "__rcs-handle-arrow",
      style: {
        width: 0,
        height: 0,
        borderTop: "8px solid transparent",
        borderRight: "10px solid",
        borderBottom: "8px solid transparent",
        transform: e ? "rotate(180deg)" : void 0
      }
    });
  },
  F = function F(_ref4) {
    var _ref4$className = _ref4.className,
      e = _ref4$className === void 0 ? "__rcs-handle-root" : _ref4$className,
      t = _ref4.disabled,
      r = _ref4.buttonStyle,
      o = _ref4.linesStyle,
      i = _ref4.portrait,
      m = _ref4.style,
      C = _objectWithoutProperties(_ref4, _excluded2);
    var u = _objectSpread({
        display: "flex",
        flexDirection: i ? "row" : "column",
        placeItems: "center",
        height: "100%",
        cursor: t ? "not-allowed" : i ? "ns-resize" : "ew-resize",
        pointerEvents: "none",
        color: "#fff"
      }, m),
      E = _objectSpread({
        flexGrow: 1,
        height: i ? 2 : "100%",
        width: i ? "100%" : 2,
        backgroundColor: "currentColor",
        pointerEvents: "auto",
        boxShadow: "0 0 4px rgba(0,0,0,.5)"
      }, o),
      y = _objectSpread({
        display: "grid",
        gridAutoFlow: "column",
        gap: 8,
        placeContent: "center",
        flexShrink: 0,
        width: 56,
        height: 56,
        borderRadius: "50%",
        borderStyle: "solid",
        borderWidth: 2,
        pointerEvents: "auto",
        backdropFilter: "blur(7px)",
        WebkitBackdropFilter: "blur(7px)",
        backgroundColor: "rgba(0, 0, 0, 0.125)",
        boxShadow: "0 0 4px rgba(0,0,0,.35)",
        transform: i ? "rotate(90deg)" : void 0
      }, r);
    return ne("div", _objectSpread(_objectSpread({}, C), {}, {
      className: e,
      style: u,
      children: [H("div", {
        className: "__rcs-handle-line",
        style: E
      }), ne("div", {
        className: "__rcs-handle-button",
        style: y,
        children: [H(re, {}), H(re, {
          flip: !0
        })]
      }), H("div", {
        className: "__rcs-handle-line",
        style: E
      })]
    }));
  };
import { useCallback as ge, useEffect as O, useLayoutEffect as Le, useRef as N } from "react";
var $ = function (i) {
    return i.ARROW_LEFT = "ArrowLeft", i.ARROW_RIGHT = "ArrowRight", i.ARROW_UP = "ArrowUp", i.ARROW_DOWN = "ArrowDown", i;
  }($ || {}),
  G = function G() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$boxSizing = _ref5.boxSizing,
      e = _ref5$boxSizing === void 0 ? "border-box" : _ref5$boxSizing,
      _ref5$objectFit = _ref5.objectFit,
      t = _ref5$objectFit === void 0 ? "cover" : _ref5$objectFit,
      _ref5$objectPosition = _ref5.objectPosition,
      r = _ref5$objectPosition === void 0 ? "center center" : _ref5$objectPosition,
      o = _objectWithoutProperties(_ref5, _excluded3);
    return _objectSpread({
      display: "block",
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      boxSizing: e,
      objectFit: t,
      objectPosition: r
    }, o);
  },
  oe = function oe(e) {
    var t = N(e);
    return O(function () {
      t.current = e;
    }), t.current;
  },
  U = function U(e, t, r, o) {
    var i = N();
    O(function () {
      i.current = t;
    }, [t]), O(function () {
      if (!(r && r.addEventListener)) return;
      var m = function m(C) {
        return i.current && i.current(C);
      };
      return r.addEventListener(e, m, o), function () {
        r.removeEventListener(e, m, o);
      };
    }, [e, r, o]);
  },
  Te = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Le : O,
  ie = function ie(e, t) {
    var r = N(),
      o = ge(function () {
        e.current && r.current && r.current.observe(e.current);
      }, [e]);
    Te(function () {
      return r.current = new ResizeObserver(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          i = _ref7[0];
        return t(i.contentRect);
      }), o(), function () {
        r.current && r.current.disconnect();
      };
    }, [t, o]);
  };
import { jsx as Y, jsxs as xe } from "react/jsx-runtime";
var I = {
    capture: !1,
    passive: !0
  },
  X = {
    capture: !0,
    passive: !1
  },
  Me = function Me(e) {
    e.preventDefault(), e.currentTarget.focus();
  },
  se = be(function (_ref8, de) {
    var _ref8$boundsPadding = _ref8.boundsPadding,
      e = _ref8$boundsPadding === void 0 ? 0 : _ref8$boundsPadding,
      _ref8$browsingContext = _ref8.browsingContext,
      t = _ref8$browsingContext === void 0 ? globalThis : _ref8$browsingContext,
      _ref8$changePositionO = _ref8.changePositionOnHover,
      r = _ref8$changePositionO === void 0 ? !1 : _ref8$changePositionO,
      _ref8$disabled = _ref8.disabled,
      o = _ref8$disabled === void 0 ? !1 : _ref8$disabled,
      i = _ref8.handle,
      m = _ref8.itemOne,
      C = _ref8.itemTwo,
      _ref8$keyboardIncreme = _ref8.keyboardIncrement,
      u = _ref8$keyboardIncreme === void 0 ? "5%" : _ref8$keyboardIncreme,
      _ref8$onlyHandleDragg = _ref8.onlyHandleDraggable,
      E = _ref8$onlyHandleDragg === void 0 ? !1 : _ref8$onlyHandleDragg,
      y = _ref8.onPositionChange,
      _ref8$portrait = _ref8.portrait,
      a = _ref8$portrait === void 0 ? !1 : _ref8$portrait,
      _ref8$position = _ref8.position,
      g = _ref8$position === void 0 ? 50 : _ref8$position,
      le = _ref8.style,
      ce = _ref8.transition,
      pe = _objectWithoutProperties(_ref8, _excluded4);
    var p = M(null),
      j = M(null),
      f = M(null),
      d = M(g),
      _V = V(!1),
      _V2 = _slicedToArray(_V, 2),
      L = _V2[0],
      q = _V2[1],
      _V3 = V(!0),
      _V4 = _slicedToArray(_V3, 2),
      me = _V4[0],
      x = _V4[1],
      w = M(!1),
      _V5 = V(),
      _V6 = _slicedToArray(_V5, 2),
      ue = _V6[0],
      fe = _V6[1],
      J = oe(g),
      l = P(function (_ref9) {
        var s = _ref9.x,
          c = _ref9.y,
          R = _ref9.isOffset;
        var b = p.current,
          A = f.current,
          D = j.current,
          _b$getBoundingClientR = b.getBoundingClientRect(),
          h = _b$getBoundingClientR.width,
          S = _b$getBoundingClientR.height,
          Pe = _b$getBoundingClientR.left,
          Ee = _b$getBoundingClientR.top;
        if (h === 0 || S === 0) return;
        var ye = a ? R ? c - Ee - t.scrollY : c : R ? s - Pe - t.scrollX : s,
          Q = Math.min(Math.max(ye / (a ? S : h) * 100, 0), 100),
          z = a ? S / (b.offsetHeight || 1) : h / (b.offsetWidth || 1),
          Z = e * z / (a ? S : h) * 100,
          _ = Math.min(Math.max(Q, Z * z), 100 - Z * z);
        d.current = Q, A.setAttribute("aria-valuenow", "".concat(Math.round(d.current))), A.style.top = a ? "".concat(_, "%") : "0", A.style.left = a ? "0" : "".concat(_, "%"), D.style.clipPath = a ? "inset(".concat(_, "% 0 0 0)") : "inset(0 0 0 ".concat(_, "%)"), y && y(d.current);
      }, [e, y, a, t]);
    k(function () {
      var _p$current$getBoundin = p.current.getBoundingClientRect(),
        n = _p$current$getBoundin.width,
        s = _p$current$getBoundin.height,
        c = g === J ? d.current : g;
      l({
        x: n / 100 * c,
        y: s / 100 * c
      });
    }, [e, g, a, J, l]);
    var Re = P(function (n) {
        n.preventDefault(), !(o || n.button !== 0) && (l({
          isOffset: !0,
          x: n.pageX,
          y: n.pageY
        }), q(!0), x(!0));
      }, [o, l]),
      v = P(function (s) {
        l({
          isOffset: !0,
          x: s.pageX,
          y: s.pageY
        }), x(!1);
      }, [l]),
      T = P(function () {
        q(!1), x(!0);
      }, []),
      Se = P(function (_ref10) {
        var n = _ref10.width,
          s = _ref10.height;
        var _p$current$getBoundin2 = p.current.getBoundingClientRect(),
          c = _p$current$getBoundin2.width,
          R = _p$current$getBoundin2.height;
        l({
          x: n / 100 * d.current * c / n,
          y: s / 100 * d.current * R / s
        });
      }, [l]),
      Ce = P(function (n) {
        if (!Object.values($).includes(n.key)) return;
        n.preventDefault(), x(!0);
        var _f$current$getBoundin = f.current.getBoundingClientRect(),
          s = _f$current$getBoundin.top,
          c = _f$current$getBoundin.left,
          _p$current$getBoundin3 = p.current.getBoundingClientRect(),
          R = _p$current$getBoundin3.width,
          b = _p$current$getBoundin3.height,
          D = typeof u == "string" ? parseFloat(u) : u / R * 100,
          h = a ? n.key === "ArrowLeft" || n.key === "ArrowDown" : n.key === "ArrowRight" || n.key === "ArrowUp",
          S = Math.min(Math.max(h ? d.current + D : d.current - D, 0), 100);
        l({
          x: a ? c : R * S / 100,
          y: a ? b * S / 100 : s
        });
      }, [u, a, l]);
    k(function () {
      fe(E ? f.current : p.current);
    }, [E]), k(function () {
      var n = p.current,
        s = function s() {
          L || T();
        };
      return r && (n.addEventListener("pointermove", v, I), n.addEventListener("pointerleave", s, I)), function () {
        n.removeEventListener("pointermove", v), n.removeEventListener("pointerleave", s);
      };
    }, [r, v, T, L]), k(function () {
      return L && !w.current && (t.addEventListener("pointermove", v, I), t.addEventListener("pointerup", T, I), w.current = !0), function () {
        w.current && (t.removeEventListener("pointermove", v), t.removeEventListener("pointerup", T), w.current = !1);
      };
    }, [v, T, L, t]), He(de, function () {
      return {
        rootContainer: p.current,
        handleContainer: f.current,
        setPosition: function setPosition(n) {
          var _p$current$getBoundin4 = p.current.getBoundingClientRect(),
            s = _p$current$getBoundin4.width,
            c = _p$current$getBoundin4.height;
          l({
            x: s / 100 * n,
            y: c / 100 * n
          });
        }
      };
    }, [l]), ie(p, Se), U("keydown", Ce, f.current, X), U("click", Me, f.current, X), U("pointerdown", Re, ue, X);
    var ve = i || Y(F, {
        disabled: o,
        portrait: a
      }),
      K = me ? ce : void 0,
      he = _objectSpread({
        position: "relative",
        display: "flex",
        overflow: "hidden",
        cursor: L ? a ? "ns-resize" : "ew-resize" : void 0,
        touchAction: "none",
        userSelect: "none",
        KhtmlUserSelect: "none",
        msUserSelect: "none",
        MozUserSelect: "none",
        WebkitUserSelect: "none"
      }, le);
    return xe("div", _objectSpread(_objectSpread({}, pe), {}, {
      ref: p,
      style: he,
      "data-rcs": "root",
      children: [m, Y(B, {
        ref: j,
        transition: K,
        children: C
      }), Y(W, {
        disabled: o,
        portrait: a,
        position: Math.round(d.current),
        ref: f,
        transition: K,
        children: ve
      })]
    }));
  });
se.displayName = "ReactCompareSlider";
import { forwardRef as we } from "react";
import { jsx as Ae } from "react/jsx-runtime";
var ae = we(function (_ref11, r) {
  var e = _ref11.style,
    t = _objectWithoutProperties(_ref11, _excluded5);
  var o = G(e);
  return Ae("img", _objectSpread(_objectSpread({
    ref: r
  }, t), {}, {
    style: o,
    "data-rcs": "image"
  }));
});
ae.displayName = "ReactCompareSliderImage";
import { useRef as De } from "react";
var _e = function _e() {
  return De({
    rootContainer: null,
    handleContainer: null,
    setPosition: function setPosition() {
      return console.warn("[react-compare-slider] `setPosition` cannot be used until the component has mounted.");
    }
  });
};
export { se as ReactCompareSlider, F as ReactCompareSliderHandle, ae as ReactCompareSliderImage, G as styleFitContainer, _e as useReactCompareSliderRef };